import axios from "axios";

const api = ({ token = null } = {}) => {
  const api_connect = axios.create({
    baseURL: process.env.REACT_APP_AUTH_API,
  });

  if (token) {
    api_connect.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  api_connect.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        return Promise.reject({ status: 401, errors: ["Unauthorized"] });
      }

      if (error.response?.status === 422) {
        let errors = Object.values(error?.response?.data?.errors || {});

        return Promise.reject({
          status: 422,
          errorsRaw: errors,
          errors: errors.reduce((err) => err),
        });
      }

      console.error(error);

      return Promise.reject({
        status: error.response?.status,
        errors: ["Oops!"],
      });
    }
  );

  return api_connect;
};

export default api;
